/* Megadropdown functionality for Lenstore sites.
 * Full rebuild Sep 2017
 * a) Nav links are always visible in HTML. First click on them opens dropdown. If dropdown already open, click follows link href.
 * b) Events fired on 1) dropdown display, 2) link click
 * Sections:
 * 1. Config
 * 2. Initial Setup Functions
 * 3. Utility Functions
 * 4. Reset Functions
 * 5. Show / Hide Functions
 * 6. Document Ready
 */ 


/* TODO: separate out currency dropdown. It should never have been set up as part of this and can be simplified */


// 1. Config
// Classnames
var mddContainerClass = "js-mdd-container";
var mddLinkClass = "js-mdd-link";
var mddContentClass = "js-mdd-content";

// Settings used for hoverIntent sections
var megaConfig = {  
	interval: 100,  
	sensitivity: 4,
	over: function(){
	  closeAllDropdowns();
	  showMenuBlock(this);
	},
	timeout: 300,
	out: function() {
	  hideMenuBlock(this);
	}
};


// 2. Initial Setup Functions

// Add the hoverintent functionality
function bindHoverIntent(containerClass) {
	$("."+containerClass).each(function() {
		$(this).hoverIntent(megaConfig);
	})
}

// Add complementary click functionality
function bindClickEvent(containerClass) {
	$("."+containerClass).find("."+mddLinkClass).on({
		"touchstart.mdd click.mdd": function(e) {
			var $mddContainer = $(this).closest("."+mddContainerClass);
			if(dropdownIsOpen($mddContainer[0])) {
				// This MDD is already open, so the link should act as a link
				return true;
			} else {
				e.preventDefault();
				e.stopPropagation();
				closeAllDropdowns();
				showMenuBlock($mddContainer);
				bindBodyInteraction();
			}
		}
	});
}

//Bind GA event to click on anchor tag within an mdd
function bindMDDGAEvents(containerClass) {
	$("."+containerClass).each(function() {
		getMDDContent(this).on("click", "a", function(e) {
			var containerLabel = $(this).closest("."+mddContentClass).data("galabel");
			var anchorLabel = $(this).data("galabel");
			GA_Event_Trigger("dropdown", "Click", containerLabel+" | "+anchorLabel);
		});
	});
}



// 3. Utility Functions
// - get a mddContainerClass's related elements; 
// - check whether a container's menu is open;

function getMDDLink(containerElement) {
	return $(containerElement).find("."+mddLinkClass);
}

function getMDDContent(containerElement) {
	return $(containerElement).find("."+mddContentClass);
}

// Test whether a dropdown within a megabutton is open
function dropdownIsOpen(containerElement) {
  return $(containerElement).hasClass("is-mega");
}


// 4. Reset Functions 

// Reset all mdd's to ground state
function closeAllDropdowns() {
	$("."+mddContainerClass).each(function() {
		if(dropdownIsOpen(this)) {
			closeDropdown(this);
		}
	})
}

// Reset a specific mdd to ground state
function closeDropdown(containerElement) {
  hideMenuBlock(containerElement);
  unbindBodyInteraction();
}


// 5. Show / Hide Functions

function showMenuBlock(containerElement){
	$linkContainer = $(containerElement);
	$linkElement = getMDDLink(containerElement);
	$linkContent = getMDDContent(containerElement);
	
	$linkContainer.addClass("is-mega");
	
	// Send a GA event when a megadropdown block is displayed.
	GA_Event_Trigger("dropdown", "Impression", $linkContent.data("galabel"));
}

// Remove mega class - hides dropdown.
function hideMenuBlock(containerElement){  
	$(containerElement).removeClass('is-mega');
}

// Add listener which closes mdd when the page is touched / clicked anywhere which isn't part of a dropdown
function bindBodyInteraction() {
// Add a listener which closes all dropdowns when anywhere in the body that is not inside a megadropdown section is clicked/touched.
  $("body").one({ 
	  'touchstart.mdd click.mdd' : function(e) {
      if(!$(e.target).closest("."+mddContainerClass).length){
	      e.preventDefault();
	      e.stopPropagation();
        closeAllDropdowns();
      }
    }
  });
}

// Remove the click / touch event from the body
function unbindBodyInteraction() {
	$("body").off("touchstart.mdd click.mdd")
}


// 6. Document Ready
$(document).ready(function() {

	// Apply hoverIntent functionality to the buttons
	bindClickEvent(mddContainerClass);
	
	// Apply hoverIntent functionality to the buttons
	bindHoverIntent(mddContainerClass);
	
	// Bind GA event to click on anchor tag within an mdd
	bindMDDGAEvents(mddContainerClass);

});